const LOCALE_OVERRIDE_GROUP_PREFIX = 'CESAPP_';

/**
 * Builds the `x-locale-override` Cube header value from simulated country codes:
 * `['DE']` → `'CESAPP_DE'`, `['DE', 'FR']` → `'CESAPP_DE,CESAPP_FR'`.
 * Codes are trimmed, upper-cased, and deduped (selection order preserved). Returns `undefined` for an
 * absent/empty/all-blank selection so the header is omitted entirely — an omitted header is what the
 * backend treats as full access.
 */
export const buildLocaleOverrideHeaderValue = (countries?: string[]): string | undefined => {
  if (!countries?.length) {
    return undefined;
  }

  const seen = new Set<string>();
  const tokens: string[] = [];
  for (const raw of countries) {
    const code = raw.trim().toUpperCase();
    if (code && !seen.has(code)) {
      seen.add(code);
      tokens.push(`${LOCALE_OVERRIDE_GROUP_PREFIX}${code}`);
    }
  }

  return tokens.length ? tokens.join(',') : undefined;
};
